// eslint-disable-next-line @typescript-eslint/no-explicit-any
const omitTypename = (key: any, value: any) => {
    return key === "__typename" ? undefined : value;
};

// TODO find better solution
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const stripTypename = (values: any) => {
    return JSON.parse(JSON.stringify(values), omitTypename);
};
